module.exports = __webpack_public_path__ + "static/media/user.12d21891.svg";